import React, { ComponentProps } from 'react';
import { BorderRoot } from './BorderWave.styles';
import { ColorTokens } from 'stitches.config';
import { theme } from 'stitches.config';

type BorderOwnProps = ComponentProps<typeof BorderRoot>;

export type BorderProps = BorderOwnProps & {
  svgWidth: string;
  svgHeight: string;
  path: string;
  background: ColorTokens;
  invert?: boolean;
  bottom?: boolean;
};

export const BorderWave: React.FC<BorderProps> = ({
  children,
  svgWidth,
  svgHeight,
  path,
  background,
  ...props
}) => {

  const backgroundColorValue = theme.colors[background].value;

  return (
    <BorderRoot
      {...props}
      css={{
        '& svg': {
          width: svgWidth,
          height: svgHeight,
        },
      }}
    >
      <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
        <path d={path} fill={backgroundColorValue}/>
      </svg>
    </BorderRoot>
  );
};

BorderWave.displayName = 'BorderWave';